// SWITCH is based on total price of plans and addons || billing cycle
export const PreviewInvoiceType = {

    SUBSCRIBE_DURING_TRIAL: 'SUBSCRIBE_DURING_TRIAL',
    SWITCH_DURING_ACTIVE_TRIAL: 'SWITCH_DURING_ACTIVE_TRIAL',
    SUBSCRIBE_AFTER_TRIAL: 'SUBSCRIBE_AFTER_TRIAL',
    SWITCH_SAME_CYCLE_UPGRADE: 'SWITCH_SAME_CYCLE_UPGRADE',
    SWITCH_SAME_CYCLE_SAME: 'SWITCH_SAME_CYCLE_SAME',
    SWITCH_SAME_CYCLE_DOWNGRADE: 'SWITCH_SAME_CYCLE_DOWNGRADE',
    SWITCH_DIFF_BILLING_CYCLE: 'SWITCH_DIFF_BILLING_CYCLE',
    SWITCH_DIFF_BILLING_CYCLE_TO_FREE_PLAN: 'SWITCH_DIFF_BILLING_CYCLE_TO_FREE_PLAN', // if switch to LAUNCH or ZERO, should always wait till current plan ends only start new plan

    // SWITCH_FREE_TO_PAID: 'SWITCH_FREE_TO_PAID', // technically same as SWITCH_SAME_CYCLE_UPGRADE | SWITCH_SAME_CYCLE_SAME | SWITCH_DIFF_BILLING_CYCLE

    // PARTNER new/update client will behave like self-billing switch (due to consolidated billing)
    // - new Client = SWITCH_SAME_CYCLE_UPGRADE
    // - update Client = SWITCH_SAME_CYCLE_UPGRADE or SWITCH_SAME_CYCLE_SAME or SWITCH_SAME_CYCLE_DOWNGRADE
};
